import { render, staticRenderFns } from "./VehicleModal.vue?vue&type=template&id=b582e864"
import script from "./VehicleModal.vue?vue&type=script&lang=js"
export * from "./VehicleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports